import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCertificates',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



return { __sfc: true,CdnImg }
}

})